import classnames from 'classnames';
import * as React from 'react';

import { IGhUspItemViewProps, IGhUspViewProps } from './gh-usp';

const UspItem: React.FC<IGhUspItemViewProps> = ({ icon, title, text, href, ariaLabel, openInNewTab }) => {
    const content = (
        <>
            <span className='gh-usp__icon' aria-hidden='true'>
                {icon}
            </span>
            <span className='gh-usp__body'>
                <span className='gh-usp__title'>{title}</span>
                {text && <span className='gh-usp__text'>{text}</span>}
            </span>
        </>
    );

    return (
        <li className='gh-usp__item'>
            {href ? (
                <a
                    className='gh-usp__inner gh-usp__inner--link'
                    href={href}
                    aria-label={ariaLabel}
                    target={openInNewTab ? '_blank' : undefined}
                    rel={openInNewTab ? 'noopener noreferrer' : undefined}
                >
                    {content}
                </a>
            ) : (
                <div className='gh-usp__inner'>{content}</div>
            )}
        </li>
    );
};

const GhUspView: React.FC<IGhUspViewProps> = props => {
    const { className, background, dividers, items } = props;

    return (
        <section
            className={classnames('gh-usp', `gh-usp--bg-${background}`, { 'gh-usp--dividers': dividers }, className)}
            style={{ '--gh-usp-columns': items.length } as React.CSSProperties}
        >
            <ul className='gh-usp__list'>
                {items.map(item => (
                    <UspItem {...item} key={item.key} />
                ))}
            </ul>
        </section>
    );
};

export default GhUspView;
